exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-upload-dragger{background:transparent!important;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4ca2a804!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/yunying/onlineMatch/matchDetail.vue
// module id = 520
// module chunks = 0